import React from 'react'
import styled from 'styled-components'
import Icon from 'components/Icon'
import { useEventSlug } from 'hooks'
import { _, colors } from 'utils'
import env from '../../../env'
import { Booth } from '../BoothList'

export const S = {
    PopoverItem: styled.div`
        min-width: 220px;
        height: 32px;
        padding: 8px 11px;
        display: flex;
        align-items: center;
        color: ${colors.icon};
        font-weight: 300;
        font-size: 14px;
        white-space: nowrap;
        border-bottom: 1px solid rgba(176, 190, 197, 0.3);
        & > span {
            margin-right: 8px;
            margin-bottom: 3px;
        }
        & > a {
            font-weight: 500;
            color: ${colors.grayTitle};
        }
    `,
}

const InfoPopover = ({ booth }: { booth: Booth }) => {
    const eventSlug = useEventSlug()
    const linkedFrom = booth?.parent?.linkedFrom || []

    return (
        <div className="popover-menu">
            <S.PopoverItem>
                <Icon icon="accountMultiple" size={18} />
                {_('booths.popover.staffs')}
                {' '}
                {`${booth?.staffMembers?.length}/${booth?.maxStaff}`}
            </S.PopoverItem>
            <S.PopoverItem>
                <Icon icon="fileDocument" size={18} />
                {_('booths.popover.documents')}
                {' '}
                {`${booth?.documents?.length}/${booth?.maxDocuments}`}
            </S.PopoverItem>
            <S.PopoverItem>
                <Icon icon="video" size={18} />
                {_('booths.popover.videos')}
                {' '}
                {`${booth?.videos?.length}/${booth?.maxVideos}`}
            </S.PopoverItem>
            {linkedFrom.length > 0 ? (linkedFrom).map((linkedItem, i) => (
                <S.PopoverItem key={i}>
                    <Icon icon="map" size={18} />
                    {_('booths.popover.link_to')}
                    &nbsp;
                    <a
                        href={`https://${env.url}${eventSlug}/map/${linkedItem.slug}`}
                        target="__blank"
                    >
                        {linkedItem?.name}
                    </a>
                </S.PopoverItem>
            )) : (
                <S.PopoverItem>
                    <Icon icon="map" size={18} />
                    {_('booths.popover.not_link_to')}
                </S.PopoverItem>
            )}
        </div>
    )
}

export default InfoPopover
